module.exports = __webpack_public_path__ + "static/img/50.ba1f014.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/Microsoft365Security/50.png
// module id = mi1b
// module chunks = 1